// extracted by mini-css-extract-plugin
export default {"wrapper":"info-view-module__wrapper","msgBlock":"info-view-module__msgBlock","img":"info-view-module__img","msg":"info-view-module__msg"};